export default function Footer() {
  return (
    <div>
      <footer>
        <div className="inner-width">
          <div className="copyright">
            &copy; 2020 | Developed with ❤️‍🔥 By <a href="#">CodeBuildder</a>
          </div>
          <div className="sm">
            <a
              href="https://twitter.com/YoungMage_"
              target="_blank"
              className="fab fa-twitter"
            ></a>
            <a
              href="https://www.linkedin.com/in/kaushikkums/"
              target="_blank"
              className="fab fa-linkedin-in"
            ></a>
            <a
              href="https://github.com/CodeBuildder"
              target="_blank"
              className="fab fa-github"
            ></a>
            <a
              href="https://www.qwiklabs.com/public_profiles/d523be57-a399-4e30-aa43-fff446440f54"
              target="_blank"
              className="fab fa-google"
            ></a>
          </div>
        </div>
      </footer>

      <button className="goTop fas fa-arrow-up"></button>
    </div>
  );
}
